{
  "app": {
    "name": "JagdManager"
  },
  "auth": {
    "actionHandler": {
      "recoverEmail": {
        "advisoryAction": "Du kannst das entweder nach dem Login auf der Seite mit deinen Konto-Informationen tun oder du forderst",
        "advisoryMessage": "Hast du die E-Mail-Adresse zurückgesetzt, weil jemand anders diese Änderung vorgenommen hat, solltest du dringend auch dein Passwort ändern.",
        "advisoryOr": "oder wende dich an",
        "advisoryResetLink": "hier einen Link zum Zurücksetzen deines Passworts an",
        "invalidContact": "Falls du keinen Zugriff mehr auf dein Konto haben solltest, weil jemand anders ohne deine Zustimmung deine E-Mail-Adresse geändert hat, wende dich bitte an",
        "invalidMessage": "Der Code zum Zurücksetzen der E-Mail-Adresse ist ungültig. Möglicherweise ist er abgelaufen oder wurde bereits verwendet.",
        "invalidTitle": "Code ungültig",
        "successMessage": "Deine E-Mail-Adresse wurde erfolgreich auf",
        "title": "E-Mail-Adresse zurückgesetzt"
      },
      "resetPassword": {
        "accountHint": "Du versuchst das Passwort für den folgenden Account zurückzusetzen:",
        "confirmPassword": "Passwort bestätigen",
        "invalidCode": "Der Code zum Zurücksetzen des Passworts ist ungültig. Möglicherweise ist er abgelaufen oder wurde bereits verwendet.",
        "newPassword": "Neues Passwort",
        "requestNewCode": "Hier einen neuen Code anfordern",
        "submit": "Passwort ändern",
        "submitError": "Fehler beim Zurücksetzen des Passworts. Bitte versuche es erneut.",
        "title": "Neues Passwort festlegen"
      },
      "title": "Aktion wird verarbeitet",
      "verifyEmail": {
        "continue": "Weiter",
        "invalidMessage": "Der Code zum Bestätigen der E-Mail-Adresse ist ungültig. Möglicherweise ist er abgelaufen oder wurde bereits verwendet.",
        "invalidRequestLink": "hier",
        "invalidRequestNew": "Wenn du die E-Mail-Adresse noch immer bestätigen möchtest, fordere bitte einen neuen Code an:",
        "invalidTitle": "Code ungültig",
        "successMessage": "Deine E-Mail-Adresse wurde erfolgreich bestätigt. Du kannst nun auf alle Funktionen des Portals zugreifen.",
        "title": "E-Mail-Adresse bestätigt"
      },
      "verifying": "Code wird verifiziert …"
    },
    "login": {
      "createAccount": {
        "prefix": "Du hast noch kein Konto?",
        "postfix": "Registrieren"
      },
      "email": "E-Mail",
      "forgotPassword": "Passwort vergessen?",
      "password": "Passwort",
      "submit": "Anmelden",
      "title": "Melde Dich an"
    },
    "register": {
      "alreadyHaveAccount": {
        "prefix": "Du hast bereits ein Konto?",
        "postfix": "Anmelden"
      },
      "confirmPassword": "Passwort bestätigen",
      "email": "E-Mail",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "password": "Passwort",
      "submit": "Registrieren",
      "title": "Erstelle ein neues Konto"
    },
    "resetPassword": {
      "backToLogin": "Zurück zum Login",
      "email": "E-Mail",
      "emailSent": "E-Mail wurde gesendet. Bitte überprüfe deinen Posteingang.",
      "submit": "Link senden",
      "subtitle": "Wir senden Dir einen Link per E-Mail",
      "title": "Passwort zurücksetzen"
    }
  },
  "calendar": {
    "noEvents": "Keine Ereignisse.",
    "noEventsOnDate": "Keine Ereignisse an diesem Tag.",
    "selectEvent": "Wähle ein Ereignis aus, um Details anzuzeigen.",
    "goToToday": "Heute",
    "search": {
      "placeholder": "Ereignisse suchen…"
    },
    "event": {
      "create": "Neues Ereignis",
      "edit": "Ereignis bearbeiten",
      "delete": "Ereignis löschen",
      "wholeDay": "Ganztägig",
      "rsvp": "Deine Antwort",
      "confirm": "Zusagen",
      "reject": "Absagen",
      "awaitingResponse": "Antwort ausstehend"
    },
    "dialog": {
      "createTitle": "Neues Ereignis",
      "editTitle": "Ereignis bearbeiten"
    },
    "fields": {
      "title": "Titel",
      "titlePlaceholder": "Titel des Ereignisses",
      "begin": "Startdatum",
      "beginTime": "Startzeit",
      "end": "Enddatum",
      "endTime": "Endzeit",
      "wholeDay": "Ganztägig",
      "location": "Ort",
      "contact": "Kontakt",
      "notice": "Notizen",
      "color": "Farbe",
      "attendees": "Teilnehmer"
    },
    "attendees": {
      "add": "Teilnehmer hinzufügen…",
      "remove": "Teilnehmer entfernen"
    },
    "validation": {
      "titleRequired": "Ein Titel ist erforderlich.",
      "endBeforeBegin": "Das Ende muss nach dem Beginn liegen."
    }
  },
  "cameras": {
    "add": "Kamera hinzufügen",
    "back": "Zurück",
    "collections": "Sammlungen",
    "details": {
      "aiSuggestion": {
        "accept": "Vorschlag übernehmen",
        "reject": "Vorschlag ablehnen",
        "suggested": "KI-Vorschlag",
        "toggleBoundingBoxes": "Erkennungsrahmen ein-/ausblenden",
        "detected": "KI-Erkennung",
        "untrackedHint": "Diese Klassifizierung wird nicht als Markierung geführt"
      },
      "chooseInterval": "Intervall wählen",
      "generatedAt": "Statistik erzeugt am",
      "images": "Aufnahmen",
      "intervals": {
        "24h": "24 Stunden",
        "7d": "7 Tage"
      },
      "cancelSelection": "Abbrechen",
      "delete": "Löschen",
      "deleteImage": "Bild löschen",
      "confirmDelete": "Bild löschen?",
      "deleting": "Wird gelöscht...",
      "loadMore": "Mehr laden",
      "select": "Auswählen",
      "selectImage": "Bild auswählen",
      "selected": "ausgewählt",
      "tag": "Markieren",
      "viewImage": "Bild ansehen",
      "nextInterval": "Nächstes Intervall",
      "previousInterval": "Vorheriges Intervall",
      "statistics": "Aufnahme-Statistiken",
      "subscription": {
        "subscribe": "Abonnieren",
        "subscribed": "Abonniert",
        "tooltip": "E-Mail-Benachrichtigungen bei neuen Fotos"
      },
      "viewer": {
        "close": "Schließen",
        "previous": "Vorheriges Bild",
        "next": "Nächstes Bild",
        "delete": "Bild löschen",
        "share": "Bild teilen",
        "linkCopied": "Link kopiert"
      },
      "moreSpecies": "Weitere Arten",
      "note": "Notiz"
    },
    "dialog": {
      "title": "Kamera hinzufügen",
      "editTitle": "Kamera bearbeiten",
      "edit": "Kamera bearbeiten",
      "secacamId": "Secacam-Kamera-ID",
      "note": "Notiz"
    },
    "filter": {
      "label": "Nach Art filtern",
      "showMore": "{{count}} weitere Arten anzeigen",
      "showLess": "Weniger Arten anzeigen",
      "clear": "Filter zurücksetzen"
    },
    "images": "Aufnahmen",
    "name": "Name",
    "noCameras": "Keine Kameras vorhanden.",
    "noImages": "Keine Aufnahmen vorhanden.",
    "allImages": "Alle Aufnahmen",
    "status": {
      "online": "Online",
      "offline": "Offline",
      "unknown": "Status unbekannt",
      "power": {
        "cable": "Netzbetrieb",
        "battery": "Batteriebetrieb",
        "unknown": "Stromquelle unbekannt"
      }
    },
    "video": {
      "request": "Video anfordern",
      "play": "Video abspielen",
      "showPhoto": "Foto anzeigen",
      "requested": "Video angefordert",
      "requestedAgo": "Angefordert: {{time}}",
      "requestedHint": "Die Kamera lädt das Video bei ihrer nächsten Verbindung hoch. Das kann bis zu einen Tag dauern.",
      "noPermission": "Dein Secacam-Konto darf für diese Kamera keine Videos anfordern.",
      "noCredits": "Für diese Kamera sind keine Video-Guthaben mehr übrig, deshalb können gerade keine Videos angefordert werden.",
      "lowWarning": "Für diese Kamera sind nur noch wenige Video-Guthaben übrig.",
      "requestFailed": "Video konnte nicht angefordert werden: {{reason}}",
      "badge": {
        "requestable": "Video kann angefordert werden",
        "requested": "Video angefordert",
        "available": "Video verfügbar"
      },
      "filter": {
        "label": "Nach Video filtern",
        "requested": "Angefordert",
        "available": "Verfügbar"
      },
      "confirm": {
        "title": "Video anfordern?",
        "text": "Für dieses Video wird ein Video-Guthaben deines Secacam-Kontos verbraucht.",
        "delay": "Die Kamera lädt das Video bei ihrer nächsten Verbindung hoch, das kann bis zu einen Tag dauern.",
        "action": "Video anfordern"
      },
      "quota": {
        "unlimited": "Unbegrenzte Video-Guthaben",
        "remaining": "Noch {{remaining}} von {{total}} Video-Guthaben"
      }
    },
    "videos": "Videos",
    "noVideos": "Noch keine Videos."
  },
  "common": {
    "all": "Alle",
    "back": "Zurück",
    "cancel": "Abbrechen",
    "clear": "Löschen",
    "close": "Schließen",
    "comingSoon": "Demnächst verfügbar",
    "create": "Erstellen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "loadError": "Fehler beim Laden: {{error}}",
    "logout": "Abmelden",
    "members": "Mitglieder",
    "ok": "Okay",
    "profile": "Profil",
    "retry": "Erneut versuchen",
    "save": "Speichern",
    "togglePassword": "Passwort anzeigen/ausblenden"
  },
  "config": {
    "language": {
      "de": "Deutsch",
      "description": "Wähle die Sprache der App.",
      "en": "Englisch",
      "title": "Sprache"
    },
    "theme": {
      "dark": "Dunkel",
      "description": "Wähle das Erscheinungsbild der App.",
      "light": "Hell",
      "system": "System",
      "title": "Design"
    },
    "title": "Einstellungen"
  },
  "confirmEmailBanner": {
    "message": "E-Mail-Bestätigung ausstehend"
  },
  "directions": {
    "N": "Nord",
    "NO": "Nordost",
    "O": "Ost",
    "SO": "Südost",
    "S": "Süd",
    "SW": "Südwest",
    "W": "West",
    "NW": "Nordwest"
  },
  "errors": {
    "auth": {
      "emailAlreadyInUse": "Es existiert bereits ein Konto mit dieser E-Mail-Adresse.",
      "invalidCredentials": "Ungültige E-Mail-Adresse oder ungültiges Passwort.",
      "networkError": "Netzwerkfehler. Bitte überprüfe deine Verbindung und versuche es erneut.",
      "requiresRecentLogin": "Bitte melde dich erneut an, um diese Aktion abzuschließen.",
      "tooManyRequests": "Zu viele Versuche. Bitte versuche es später erneut.",
      "userDisabled": "Dieses Konto wurde deaktiviert.",
      "weakPassword": "Das Passwort ist zu schwach."
    },
    "deleteAccountFailed": "Das Konto konnte nicht gelöscht werden",
    "emailVerificationFailed": "Die Bestätigungs-E-Mail konnte nicht versendet werden",
    "loadFailed": "Laden fehlgeschlagen",
    "loginFailed": "Einloggen fehlgeschlagen",
    "logoutFailed": "Ausloggen fehlgeschlagen",
    "noUserLoggedIn": "Kein Benutzer angemeldet",
    "passwordResetEmailFailed": "Fehler beim Versenden der Passwort-Reset-E-Mail.",
    "registrationFailed": "Registrierung konnte nicht durchgeführt werden.",
    "updateFailed": "Fehler beim Aktualisieren",
    "generic": "Ein unbekannter Fehler ist aufgetreten.",
    "status": {
      "400": "Ungültige Anfrage.",
      "403": "Keine Berechtigung für diese Aktion.",
      "404": "Die angeforderte Ressource wurde nicht gefunden.",
      "409": "Konflikt: Die Aktion konnte nicht durchgeführt werden.",
      "500": "Serverfehler. Bitte versuche es später erneut."
    },
    "codes": {
      "BAD_REQUEST": "Ungültige Anfrage.",
      "HAS_DEPENDENTS": "Kann nicht gelöscht werden – noch in Verwendung von: {{items}}.",
      "NOT_FOUND": "Die Ressource wurde nicht gefunden.",
      "FORBIDDEN": "Keine Berechtigung für diese Aktion.",
      "KEY_NOT_ALLOWED": "Dieser Schlüssel ist nicht erlaubt.",
      "CODE_ALREADY_USED": "Dieser Code wurde bereits verwendet.",
      "NO_RECIPIENT": "Kein Empfänger angegeben.",
      "NO_TOKEN": "Kein Token vorhanden.",
      "VALIDATION_ERROR": "Die Eingabe ist ungültig.",
      "INVALID_TOKEN": "Ungültiger Token.",
      "TOKEN_EXPIRED": "Token abgelaufen. Bitte melde dich erneut an.",
      "SERVER_ERROR": "Serverfehler. Bitte versuche es später erneut.",
      "INVALID_API_KEY": "Ungültiger API-Schlüssel.",
      "MISSING_ACTION_CODE": "Action-Code fehlt.",
      "UNAUTHORIZED": "Nicht autorisiert.",
      "NETWORK": "Netzwerkfehler. Bitte prüfe deine Verbindung.",
      "UNKNOWN": "Ein unbekannter Fehler ist aufgetreten.",
      "SECACAM_VIDEO_NOT_RECORDED": "Die Kamera hat zu diesem Foto kein Video aufgezeichnet.",
      "SECACAM_VIDEO_ALREADY_REQUESTED": "Dieses Video wurde bereits angefordert.",
      "SECACAM_CAMERA_NOT_MAPPED": "Diese Kamera ist noch nicht mit einer Secacam-Kamera verknüpft.",
      "SECACAM_CAMERA_NOT_FOUND": "Die verknüpfte Secacam-Kamera wurde nicht gefunden.",
      "SECACAM_VIDEO_NO_CREDITS": "Es sind keine Video-Guthaben mehr übrig.",
      "SECACAM_CAMERA_OFFLINE": "Die Kamera ist gerade offline. Bitte versuche es später erneut.",
      "SECACAM_VIDEO_NO_PERMISSION": "Dein Secacam-Konto darf für diese Kamera keine Videos anfordern.",
      "SECACAM_VIDEO_REQUEST_FAILED": "Die Anfrage konnte nicht an die Kamera gesendet werden. Bitte versuche es erneut.",
      "SECACAM_UNAVAILABLE": "Der Kameradienst ist gerade nicht erreichbar. Bitte versuche es später erneut.",
      "SECACAM_CAMERA_IDENT_UNKNOWN": "Die Kamera konnte nicht erkannt werden. Bitte prüfe die verknüpfte Kamera."
    }
  },
  "game": {
    "add": "Erlegung erfassen",
    "age": {
      "young": "Jung",
      "adult": "Ausgewachsen",
      "unknown": "Unbekannt"
    },
    "chart": {
      "byAge": "Nach Alter",
      "bySex": "Nach Geschlecht",
      "bySpecies": "Nach Wildart",
      "clickToFilter": "Klicke auf Wildart für Details"
    },
    "charts": "Statistiken",
    "confirm": {
      "delete": "Erlegung wirklich löschen?"
    },
    "delete": "Erlegung löschen",
    "edit": "Erlegung bearbeiten",
    "export": "Excel exportieren",
    "fields": {
      "addPhoto": "Foto hinzufügen",
      "age": "Alter",
      "comment": "Bemerkung",
      "date": "Datum",
      "hunter": "Erleger",
      "location": "Erlegungsort",
      "photos": "Fotos",
      "sample": "Trichinenprobe",
      "sex": "Geschlecht",
      "species": "Wildart",
      "time": "Uhrzeit"
    },
    "huntingYear": "Jagdjahr",
    "noEntries": "Keine Erlegungen vorhanden.",
    "sex": {
      "female": "Weiblich",
      "male": "Männlich"
    },
    "species": {
      "badger": "Dachs",
      "wildBoar": "Schwarzwild",
      "hare": "Feldhase",
      "redDeer": "Rotwild",
      "redFox": "Fuchs",
      "roeDeer": "Rehwild"
    },
    "table": {
      "age": "Alter",
      "comment": "Bemerkung",
      "date": "Datum",
      "hunter": "Erleger",
      "location": "Ort",
      "number": "Nr.",
      "sample": "Trichinenprobe",
      "sex": "Geschlecht",
      "species": "Wildart",
      "time": "Uhrzeit"
    },
    "title": "Erlegungen",
    "viewPhotos": "Fotos anzeigen",
    "viewerClose": "Viewer schließen",
    "viewerPrev": "Vorheriges Bild",
    "viewerNext": "Nächstes Bild"
  },
  "header": {
    "menuOpen": "Menü öffnen",
    "notifications": "Aufgaben und Benachrichtigungen",
    "selectHuntingGround": "Revier wählen",
    "userAccount": "Benutzerkonto"
  },
  "hides": {
    "addImage": "Bild hinzufügen",
    "removeImage": "Bild entfernen",
    "create": "Ansitzeinrichtung erstellen",
    "directions": "Windrichtungen",
    "edit": "Ansitzeinrichtung bearbeiten",
    "filterByDirection": "Nach Windrichtung filtern",
    "focalPoint": {
      "hint": "Tippe um den sichtbaren Ausschnitt festzulegen",
      "ariaLabel": "Sichtbaren Bildausschnitt festlegen. Mit den Pfeiltasten anpassen."
    },
    "filterMode": {
      "all": "Alle müssen zutreffen",
      "any": "Min. 1 muss zutreffen"
    },
    "image": "Bild",
    "name": "Name",
    "noHides": "Keine Ansitzeinrichtungen vorhanden.",
    "type": "Typ",
    "types": {
      "drivenHuntHide": "Drückbock",
      "hide": "Kanzel",
      "mobileHide": "Mobile Kanzel",
      "openHide": "Offene Kanzel",
      "scissorLadder": "Scherenleiter",
      "seatLadder": "Ansitzleiter",
      "treeLadder": "Baumleiter"
    }
  },
  "huntingGround": {
    "accept": "Annehmen",
    "createNew": "Neues Revier erstellen",
    "decline": "Ablehnen",
    "incomingInvitations": "Einladungen",
    "invitedBy": "Eingeladen von {{name}}",
    "nameLabel": "Name des Reviers",
    "namePlaceholder": "z.B. Barweiler Nord",
    "newHuntingGround": "Neues Revier",
    "noHuntingGrounds1": "Du bist aktuell in keinem Revier als Teilnehmer eingetragen.",
    "noHuntingGrounds2": "Erstelle ein neues Revier oder warte auf eine Einladung.",
    "title": "Reviere",
    "yourHuntingGrounds": "Deine Reviere"
  },
  "invitation": {
    "title": "Einladung annehmen",
    "accepting": "Einladung wird angenommen...",
    "success": "Du wurdest erfolgreich zum Revier \"{{huntingGround}}\" hinzugefügt.",
    "error": "Die Einladung konnte nicht angenommen werden.",
    "expiredOrUsed": "Der Einladungslink ist abgelaufen oder wurde bereits verwendet.",
    "toHuntingGround": "Zum Revier",
    "toHome": "Zur Startseite"
  },
  "map": {
    "tags": {
      "label": "Schlagwörter",
      "addPlaceholder": "Schlagwort hinzufügen",
      "createPrefix": "Erstellen",
      "removeChip": "Schlagwort entfernen",
      "filterTitle": "Nach Schlagwort filtern",
      "clear": "Zurücksetzen",
      "delete": "Schlagwort löschen",
      "noTags": "Noch keine Schlagwörter. Füge welche beim Bearbeiten einer Markierung oder eines Polygons hinzu.",
      "deleteDialog": {
        "title": "Schlagwort löschen",
        "message": "Dieses Schlagwort wird noch von {{count}} Objekt(en) verwendet. Beim Löschen wird es von allen entfernt. Fortfahren?",
        "confirm": "Trotzdem löschen"
      }
    },
    "marker": {
      "color": "Farbe",
      "create": "Neue Markierung",
      "edit": "Markierung bearbeiten",
      "editPosition": "Position bearbeiten",
      "hide": "Ansitzeinrichtung",
      "hideImageAlt": "Foto der Ansitzeinrichtung",
      "name": "Name",
      "noHide": "Keine",
      "type": "Typ",
      "types": {
        "baitSite": "Kirrung",
        "camera": "Kamera",
        "cameraSending": "Kamera mit Sendefunktion",
        "drivenHuntHide": "Drückjagdbock",
        "hide": "Geschlossene Kanzel",
        "ladder": "Baumleiter",
        "mobileHide": "Mobile Kanzel",
        "new": "Neue Markierung",
        "openHide": "Offene Kanzel",
        "saltLick": "Salzlecke",
        "scissorLadder": "Scherenleiter",
        "seatLadder": "Ansitzleiter",
        "tbd": "Ausstehend",
        "trash": "Müll"
      }
    },
    "confirmMarker": "Markierung bestätigen",
    "cancelMarker": "Abbrechen",
    "confirmPolygon": "Polygon bestätigen",
    "cancelPolygon": "Abbrechen",
    "mode": {
      "createPolygon": {
        "desktop": "Klicken um Polygon zu beginnen",
        "mobile": "Tippen um Polygon zu beginnen"
      },
      "initialLoad": "Markierungen werden geladen...",
      "markerConfirm": {
        "desktop": "Klicken, um Markierung zu bewegen",
        "mobile": "Karte bewegen, um Markierung zu verschieben"
      },
      "placeMarker": {
        "desktop": "Klicken zum Platzieren",
        "mobile": "Tippen zum Platzieren"
      },
      "polygonConfirm": {
        "desktop": "Klicken um Punkte hinzuzufügen (doppelt zum entfernen)",
        "mobile": "Tippen um Punkte hinzuzufügen (doppelt zum entfernen)"
      },
      "requestRunning": "Anfrage läuft...",
      "creatingBoundary": {
        "mobile": "Tippen um Reviergrenze zu beginnen",
        "desktop": "Klicken um Reviergrenze zu beginnen"
      },
      "boundaryConfirm": {
        "mobile": "Tippen um Punkte hinzuzufügen, bestätigen zum Speichern",
        "desktop": "Klicken um Punkte hinzuzufügen, bestätigen zum Speichern"
      },
      "selectParcels": {
        "mobile": "Flurstücke antippen zum Auswählen",
        "desktop": "Flurstücke anklicken zum Auswählen"
      },
      "parcelInfo": {
        "desktop": "Fahre über ein Flurstück, um Details zu sehen",
        "mobile": "Tippe auf ein Flurstück, um Details zu sehen"
      }
    },
    "config": {
      "drawBoundary": "Reviergrenze zeichnen",
      "editBoundary": "Reviergrenze bearbeiten",
      "weatherLocationSaved": "Wetterstandort gespeichert",
      "boundarySaved": "Reviergrenze gespeichert"
    },
    "options": {
      "apply": "Übernehmen",
      "border": "Reviergrenzen",
      "contourLines": "Höhenlinien",
      "layers": "Ebenen",
      "markerTypes": "Markierungstypen",
      "parcels": "Flurstücke",
      "parcelsZoomHint": "Weiter einzoomen um Flurstücke zu laden",
      "polygons": "Polygone",
      "title": "Kartenoptionen"
    },
    "polygon": {
      "area": "Fläche (ha)",
      "create": "Polygon erstellen",
      "edit": "Polygon bearbeiten",
      "editShape": "Form bearbeiten",
      "filled": "Gefüllt",
      "flurstuecke": "Flurstücke",
      "name": "Name",
      "outline": "Kontur",
      "perimeter": "Umfang (m)",
      "title": "Polygon"
    },
    "addMarker": "Markierung setzen",
    "createPolygon": "Polygon zeichnen",
    "selectParcels": "Flurstücke auswählen",
    "cancelSelection": "Abbrechen",
    "selection": {
      "confirm": "Polygon aus Auswahl",
      "disjointHint": "Ausgewählte Flurstücke sind nicht benachbart — größte Fläche verwendet."
    },
    "search": {
      "title": "Flurstückssuche",
      "gemarkung": "Gemarkung",
      "flur": "Flur",
      "zaehler": "Zähler",
      "nenner": "Nenner",
      "search": "Suchen",
      "noResults": "Keine Flurstücke gefunden",
      "close": "Schließen",
      "selectRow": "Auf Karte anzeigen",
      "col": {
        "nummer": "Flurstücksnummer",
        "lage": "Lage",
        "gemarkung": "Gemarkung",
        "flur": "Flur",
        "zaehler": "Zähler",
        "nenner": "Nenner"
      }
    },
    "speedDial": {
      "expand": "Aktionen öffnen",
      "collapse": "Aktionen schließen"
    },
    "parcelInfo": {
      "title": "Flurstückinfo",
      "close": "Schließen",
      "flurstueck": "Flurstück",
      "flur": "Flur",
      "gemarkung": "Gemarkung",
      "gemeinde": "Gemeinde",
      "lage": "Lage",
      "kennzeichen": "Kennzeichen",
      "area": "Fläche",
      "areaComputed": "Fläche (berechnet)",
      "perimeter": "Umfang",
      "landUse": "Nutzung"
    }
  },
  "huntingSeasons": {
    "admin": {
      "stage": {
        "title": "Jagdzeiten aktualisieren",
        "subtitle": "Scrapt alle 17 Quellen, berechnet die Änderungen und legt eine Vorschau zur Prüfung an. Die Datenbank wird erst nach Bestätigung aktualisiert.",
        "action": "Jagdzeiten aktualisieren",
        "actionTooltip": "Alle Quellen neu einlesen und Änderungen berechnen",
        "checkingPending": "Ausstehende Vorschau wird gesucht…",
        "noPending": "Keine ausstehende Vorschau vorhanden. Klicke auf 'Jagdzeiten aktualisieren', um eine neue zu erstellen.",
        "duration": "Laufzeit: {{ms}} ms",
        "syncCreatedAt": "Erstellt: {{date}}",
        "lastSynced": "Zuletzt synchronisiert: {{date}}"
      },
      "status": {
        "pending": "Ausstehend",
        "applied": "Übernommen",
        "rejected": "Verworfen",
        "superseded": "Überholt"
      },
      "counts": {
        "added": "Hinzugefügt",
        "updated": "Aktualisiert",
        "removed": "Entfernt",
        "unchanged": "Unverändert"
      },
      "sources": {
        "panelTitle": "{{count}} Quellen",
        "errorCount": "{{count}} Fehler",
        "scrapeErrorBanner": "{{count}} Quelle(n) konnten nicht verarbeitet werden.",
        "skippedRows": "{{count}} Zeile(n) übersprungen",
        "columns": {
          "state": "Bundesland",
          "status": "Status",
          "rows": "Zeilen",
          "parsed": "Eingelesen",
          "error": "Fehler / Übersprungen"
        },
        "status": {
          "success": "Erfolgreich",
          "error": "Fehler"
        }
      },
      "changes": {
        "panelTitle": "{{count}} Änderung(en)",
        "noChanges": "Keine Änderungen – alle Daten sind aktuell.",
        "columns": {
          "type": "Typ",
          "state": "Bundesland",
          "species": "Wildart",
          "before": "Vorher",
          "after": "Nachher"
        },
        "type": {
          "added": "Hinzugefügt",
          "updated": "Aktualisiert",
          "removed": "Entfernt"
        }
      },
      "apply": {
        "action": "In Datenbank übernehmen",
        "actionTooltip": "Alle Änderungen in die Datenbank schreiben",
        "confirmTitle": "Änderungen übernehmen?",
        "confirmMessage": "Änderungen übernehmen? Hinzugefügt: {{added}}, Aktualisiert: {{updated}}, Entfernt: {{removed}}",
        "success": "Änderungen wurden erfolgreich in die Datenbank übernommen."
      },
      "reject": {
        "action": "Verwerfen",
        "actionTooltip": "Vorschau verwerfen und nicht übernehmen"
      },
      "errors": {
        "loadFailed": "Ausstehende Vorschau konnte nicht geladen werden.",
        "stageFailed": "Aktualisierung fehlgeschlagen.",
        "actionFailed": "Aktion fehlgeschlagen. Bitte erneut versuchen."
      }
    },
    "display": {
      "title": "Jagdzeiten",
      "stateLabel": "Bundesland",
      "searchPlaceholder": "Wildart suchen",
      "mobileTextToggle": "Visuelle Darstellung",
      "columns": {
        "species": "Wildart",
        "class": "Klasse",
        "season": "Jagdzeit"
      },
      "class": {
        "male": "Männlich",
        "female": "Weiblich",
        "all": "Alle"
      },
      "status": {
        "protected": "Ganzjährig geschont",
        "yearRound": "Ganzjährig"
      },
      "periodJoiner": "und",
      "legend": {
        "open": "Jagdzeit",
        "closed": "Schonzeit"
      },
      "empty": "Keine Jagdzeiten für das ausgewählte Bundesland gefunden.",
      "loading": "Jagdzeiten werden geladen…",
      "error": "Jagdzeiten konnten nicht geladen werden.",
      "retry": "Erneut versuchen",
      "disclaimer": {
        "title": "Hinweis",
        "text": "Alle Angaben zu Jagd- und Schonzeiten sind ohne Gewähr. Die Daten stammen aus öffentlich zugänglichen Quellen und werden regelmäßig aktualisiert. Maßgeblich sind ausschließlich die gesetzlichen Regelungen der Bundesländer und des Bundes."
      },
      "seasonBar": {
        "label": {
          "jan": "Jan",
          "feb": "Feb",
          "mar": "Mär",
          "apr": "Apr",
          "may": "Mai",
          "jun": "Jun",
          "jul": "Jul",
          "aug": "Aug",
          "sep": "Sep",
          "oct": "Okt",
          "nov": "Nov",
          "dec": "Dez"
        }
      }
    }
  },
  "secacamAdmin": {
    "reset": {
      "title": "Kamera-Import zurücksetzen",
      "description": "Löscht den gespeicherten Import-Cursor. Der nächste geplante Lauf (in ca. 5 Minuten) holt dann bis zu 5000 Bilder der letzten 24 Stunden erneut ab.",
      "action": "Kamera-Import zurücksetzen",
      "actionTooltip": "Import-Cursor löschen, damit der nächste Lauf einen Nachhol-Import durchführt",
      "confirmTitle": "Kamera-Import zurücksetzen?",
      "confirmMessage": "Der gespeicherte Import-Cursor wird gelöscht. Der nächste geplante Lauf (in ca. 5 Minuten) holt dann bis zu 5000 Bilder der letzten 24 Stunden erneut ab.",
      "success": "Import-Cursor wurde zurückgesetzt. Der nächste Lauf holt die letzten 24 Stunden erneut ab.",
      "error": "Zurücksetzen fehlgeschlagen. Bitte erneut versuchen."
    },
    "config": {
      "title": "Import-Limits",
      "description": "Legt fest, wie weit der Kamera-Import zurückblickt und wie viele Bilder er pro Lauf maximal abholt.",
      "loading": "Aktuelle Werte werden geladen …",
      "loadError": "Werte konnten nicht geladen werden.",
      "fields": {
        "maxLookbackHours": "Max. Zeitfenster (Stunden)",
        "maxImages": "Max. Bilder pro Lauf",
        "autoTagConfidenceThreshold": "KI-Auto-Tag-Schwelle",
        "skipNoDetectionImages": "Bilder ohne KI-Erkennung überspringen"
      },
      "hints": {
        "maxLookbackHours": "{{min}}–{{max}} Stunden",
        "maxImages": "{{min}}–{{max}} Bilder",
        "autoTagConfidenceThreshold": "Nur ab dieser Erkennungssicherheit ({{min}}–{{max}}) wird automatisch getaggt",
        "skipNoDetectionImages": "Bilder, auf denen die KI nichts oder ausschließlich Vögel erkannt hat, werden nicht importiert. Andere erkannte, aber nicht getrackte Objekte (z. B. Autos) werden weiterhin importiert. Das jeweils neueste Bild einer Kamera wird pro Import trotzdem behalten und beim nächsten Import mit neueren Bildern wieder entfernt."
      },
      "errors": {
        "required": "Pflichtfeld.",
        "min": "Mindestwert: {{min}}",
        "max": "Höchstwert: {{max}}"
      },
      "action": "Speichern",
      "actionTooltip": "Import-Limits speichern",
      "saveSuccess": "Import-Limits wurden gespeichert.",
      "saveError": "Speichern fehlgeschlagen. Bitte erneut versuchen."
    },
    "aiBackfill": {
      "title": "KI-Klassifizierungen neu auswerten",
      "description": "Wertet die gespeicherten ZEISS-Rohdaten aller Bilder mit der aktuellen Artenzuordnung neu aus. Alte Bilder bekommen dadurch die neuen Arten (Dachs, Waschbär, Fuchs …) sowie die reinen Anzeige-Erkennungen (Vogel, Unbekannt). Das abgeschaffte Sammel-Tag \"Andere\" wird durch die jetzt erkannte Art ersetzt; bei Bildern ohne KI-Rohdaten entfällt es.",
      "action": "Neu auswerten",
      "actionTooltip": "Läuft seitenweise über alle Kamerabilder",
      "confirmTitle": "Klassifizierungen neu auswerten?",
      "confirmMessage": "Alle Kamerabilder werden neu ausgewertet. Markierungen mit \"Andere\" werden dabei ersetzt oder entfernt. Der Vorgang kann einige Minuten dauern.",
      "error": "Die Neuauswertung ist fehlgeschlagen.",
      "progress": {
        "scanned": "Geprüft",
        "suggestions": "Vorschläge aktualisiert",
        "remapped": "Andere ersetzt",
        "dropped": "Andere entfernt"
      }
    }
  },
  "speciesTrackingAdmin": {
    "title": "Getrackte Wildarten",
    "description": "Hier ausgeschaltete Wildarten werden nicht mehr als Filter-Chip oder als taggbare Option angeboten. Bereits so getaggte Bilder behalten ihr Tag.",
    "loading": "Aktuelle Werte werden geladen …",
    "loadError": "Werte konnten nicht geladen werden.",
    "toggleAriaLabel": "{{species}} tracken",
    "action": "Speichern",
    "actionTooltip": "Getrackte Wildarten speichern",
    "saveSuccess": "Die getrackten Wildarten wurden gespeichert.",
    "saveError": "Speichern fehlgeschlagen. Bitte erneut versuchen."
  },
  "dashboard": {
    "title": "Dashboard",
    "greeting": "Hallo, {{name}}",
    "greetings": {
      "morning": "Guten Morgen, {{name}}!",
      "afternoon": "Guten Tag, {{name}}!",
      "evening": "Guten Abend, {{name}}!",
      "night": "Gute Nacht, {{name}}!"
    },
    "noGrounds": {
      "title": "Willkommen!",
      "message": "Erstelle dein erstes Revier oder tritt einem bestehenden bei.",
      "createAction": "Revier erstellen"
    },
    "widgets": {
      "greetingHero": "Begrüßung",
      "quickActions": "Schnellaktionen",
      "myGrounds": "Meine Reviere",
      "upcomingEvents": "Nächste Termine",
      "awaitingResponse": "Offene Einladungen",
      "huntingSeasonSummary": {
        "title": "Jagdzeiten",
        "opening": "Beginnt",
        "closing": "Endet",
        "empty": "Keine Jagdzeiten beginnen oder enden in den nächsten 30 Tagen."
      },
      "stockFeed": "Lageraktivitäten",
      "myTasks": "Meine Aufgaben",
      "recentHarvest": "Letzte Erlegungen",
      "cameraStrip": "Kamerabilder",
      "members": "Mitglieder",
      "hidesSummary": "Empfohlene Ansitze",
      "activityFeed": "Aktivitäten",
      "pendingInvitations": "Ausstehende Einladungen",
      "weather": {
        "label": "Wetter",
        "noLocation": "Kein Wetterstandort für dieses Revier konfiguriert."
      }
    },
    "quickActions": {
      "addHarvest": "Erlegung",
      "addTask": "Aufgabe",
      "addStockMovement": "Lagerbewegung"
    },
    "customize": {
      "title": "Dashboard anpassen",
      "tooltip": "Dashboard anpassen",
      "dragHandle": "Verschieben"
    },
    "dragHandle": "Widget verschieben",
    "noEvents": "Keine bevorstehenden Termine",
    "noRsvpPending": "Keine offenen Einladungen",
    "viewAll": "Alle anzeigen",
    "ground": {
      "noTasks": "Keine offenen Aufgaben",
      "allTasks": "Alle Aufgaben",
      "noHarvest": "Noch keine Erlegungen",
      "allHarvest": "Alle Erlegungen",
      "noImages": "Keine Kamerabilder",
      "allImages": "Alle Bilder",
      "noMembers": "Keine Mitglieder",
      "allHides": "Alle Ansitze",
      "hidesCount": "{{count}} Ansitze",
      "windDirection": "Windrichtung: {{dir}}",
      "noWindData": "Kein Wetterdaten verfügbar.",
      "noMatchingHides": "Keine Ansitze für aktuelle Windrichtung.",
      "kpi": {
        "openTasks": "Aufgaben",
        "harvest": "Erlegungen",
        "cameras": "Kameras",
        "hides": "Ansitze"
      }
    },
    "feed": {
      "today": "Heute",
      "yesterday": "Gestern",
      "loadMore": "Mehr laden",
      "messagePlaceholder": "Nachricht an das Revier...",
      "sendTooltip": "Nachricht senden",
      "empty": "Noch keine Aktivitäten",
      "loading": "Wird geladen..."
    },
    "pendingInvitations": {
      "incomingTitle": "Eingegangene Einladungen",
      "outgoingTitle": "Versendete Einladungen",
      "accept": "Annehmen",
      "decline": "Ablehnen",
      "revoke": "Zurückziehen",
      "empty": "Keine ausstehenden Einladungen",
      "invitedBy": "Eingeladen von {{name}}"
    }
  },
  "nav": {
    "account": "Konto",
    "administration": "Administration",
    "appearance": "Erscheinungsbild",
    "bookings": "Buchungen",
    "calendar": "Kalender",
    "cameraDetails": "Kamera-Details",
    "cameraStream": "Bildstream",
    "cameras": "Kameras",
    "categories": "Kategorien",
    "configuration": "Konfiguration",
    "dashboard": "Dashboard",
    "gameHarvest": "Erlegungen",
    "general": "Allgemein",
    "hides": "Ansitzeinrichtungen",
    "huntingGround": "Revier",
    "huntingGroundOverview": "Revierübersicht",
    "huntingSeasons": "Jagdzeiten",
    "locations": "Lagerorte",
    "map": "Karte",
    "portalAdmin": "Portal Admin",
    "reservations": "Vormerkungen",
    "settings": "Einstellungen",
    "stock": "Bestand",
    "storage": "Lagerung",
    "tasks": "Aufgaben",
    "userManagement": "Benutzerverwaltung",
    "whatsNew": "Neuigkeiten"
  },
  "stockCategory": {
    "deleteDialog": {
      "title": "Kategorie löschen?",
      "message": "Diese Kategorie enthält noch Lagerbestände oder Reservierungen. Möchtest du die Kategorie trotzdem löschen? Alle zugehörigen Einträge werden dabei entfernt.",
      "confirm": "Trotzdem löschen"
    },
    "deleteError": "Kategorie konnte nicht gelöscht werden."
  },
  "stockLocation": {
    "deleteDialog": {
      "title": "Lagerort löschen?",
      "message": "Dieser Lagerort enthält noch Lagerbestände oder Reservierungen. Möchtest du ihn trotzdem löschen? Alle zugehörigen Einträge werden dabei entfernt.",
      "confirm": "Trotzdem löschen"
    },
    "deleteError": "Lagerort konnte nicht gelöscht werden."
  },
  "stock": {
    "title": "Lagerung",
    "newBooking": "Neue Buchung",
    "reserve": "Vormerken",
    "owner": "Eigentümer",
    "sharedWith": "Freigegeben",
    "noLocations": "Keine Lagerorte vorhanden. Erstelle zuerst einen Lagerort.",
    "noCategories": "Keine Kategorien vorhanden. Erstelle zuerst eine Kategorie.",
    "inventory": {
      "title": "Lagerbestand",
      "add": "Einlagern",
      "noItems": "Keine Einträge vorhanden.",
      "addFirst": "Erstelle zuerst Lagerorte und Kategorien.",
      "search": "Suche nach Lagerort, Kategorie oder Wildart...",
      "noSearchResults": "Keine Einträge gefunden."
    },
    "transaction": {
      "title": "Buchungen",
      "add": "Neue Buchung",
      "keepOpen": "Geöffnet lassen",
      "noItems": "Keine Buchungen vorhanden.",
      "type": {
        "addition": "Einlagerung",
        "removal": "Entnahme",
        "reservation": "Vormerkung",
        "fulfilled": "Ausgeführt",
        "discarded": "Verworfen"
      }
    },
    "location": {
      "title": "Lagerorte",
      "add": "Lagerort erstellen",
      "edit": "Lagerort bearbeiten",
      "noItems": "Keine Lagerorte vorhanden.",
      "share": "Freigeben",
      "owner": "Eigentümer",
      "sharedWith": "Freigegeben für",
      "noShareableMembers": "Keine Mitglieder in deinen Revieren gefunden.",
      "searchMembers": "Mitglieder suchen",
      "permissionRead": "Lesen",
      "permissionWrite": "Schreiben",
      "sharedWithCount": "Geteilt mit {{ count }} Person(en)"
    },
    "category": {
      "title": "Kategorien",
      "add": "Kategorie erstellen",
      "edit": "Kategorie bearbeiten",
      "noItems": "Keine Kategorien vorhanden.",
      "aggregate": "Aggregiert",
      "addSpecies": "Wildart hinzufügen...",
      "speciesHint": "Eingabe bestätigen mit Enter oder Komma",
      "quantityType": {
        "label": "Mengentyp",
        "integer": "Ganzzahl (z. B. Stück, Pakete)",
        "decimal": "Dezimalzahl (z. B. kg, Liter)"
      }
    },
    "reservation": {
      "title": "Vormerkungen",
      "add": "Vormerken",
      "noItems": "Keine Vormerkungen vorhanden.",
      "fulfill": "Ausführen",
      "cancel": "Stornieren",
      "status": {
        "pending": "Ausstehend",
        "fulfilled": "Ausgeführt",
        "cancelled": "Storniert"
      }
    },
    "fields": {
      "name": "Name",
      "species": "Wildart",
      "unit": "Einheit",
      "quantity": "Menge",
      "location": "Lagerort",
      "category": "Kategorie",
      "date": "Datum",
      "user": "Benutzer",
      "note": "Notiz",
      "type": "Buchungsart",
      "packagingDate": "Verarbeitungsdatum",
      "batch": "Charge"
    },
    "table": {
      "number": "#",
      "location": "Lagerort",
      "category": "Kategorie",
      "species": "Wildart",
      "quantity": "Menge",
      "unit": "Einheit",
      "date": "Datum",
      "user": "Benutzer",
      "type": "Buchungsart",
      "status": "Status",
      "note": "Notiz"
    },
    "validation": {
      "category": {
        "required": "Die Kategorie ist erforderlich"
      },
      "location": {
        "required": "Der Lagerort ist erforderlich"
      },
      "type": {
        "required": "Die Buchungsart ist erforderlich"
      },
      "quantity": {
        "required": "Die Menge ist erforderlich",
        "min": "Die angegebene Menge muss größer als 0 sein",
        "quantityMustBeInteger": "Menge muss eine Ganzzahl sein",
        "quantityExceedsStock": "Menge überschreitet den Lagerbestand"
      }
    }
  },
  "userManagement": {
    "title": "Benutzerverwaltung",
    "members": "Mitglieder",
    "invite": "Nutzer einladen",
    "inviteEmail": "E-Mail-Adresse",
    "inviteButton": "Einladen",
    "inviteSuccess": "Einladung wurde versendet.",
    "pendingInvitations": "Ausstehende Einladungen",
    "pendingStatus": "Ausstehend",
    "removeUser": "Nutzer entfernen",
    "removeConfirm": "Soll dieser Nutzer wirklich entfernt werden?",
    "revokeInvitation": "Einladung zurückziehen",
    "changeRole": "Rolle ändern",
    "roleChanged": "Rolle wurde geändert.",
    "noMembers": "Keine Mitglieder vorhanden.",
    "roleAdministrator": "System Admin"
  },
  "notFound": {
    "message": "Die angeforderte Seite existiert nicht.",
    "title": "Seite nicht gefunden"
  },
  "poi": {
    "addImage": "Bild hinzufügen",
    "clickToAddMarker": "Klicken, um Markierung zu setzen",
    "compressing": "Bild wird komprimiert…",
    "confirmMarker": "Markierung bestätigen",
    "imageAlt": "Orientierungspunkt",
    "imageLabel": "Bild",
    "markerPlaceholder": "z.B. 100 m",
    "noImages": "Keine Bilder vorhanden.",
    "removeImage": "Bild entfernen",
    "removeMarker": "Markierung entfernen",
    "showMarkerDetails": "Markierungsdetails anzeigen",
    "title": "Orientierungspunkte",
    "uploading": "Bild wird hochgeladen…"
  },
  "profile": {
    "changePassword": "Passwort ändern",
    "confirmPassword": "Passwort bestätigen",
    "deleteAccount": "Konto löschen",
    "deleteAccountWarning": "Achtung: Das Löschen deines Kontos ist unwiderruflich. Alle deine Daten werden dauerhaft entfernt.",
    "displayName": "Anzeigename",
    "email": "E-Mail",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "newPassword": "Neues Passwort",
    "passwordChanged": "Passwort wurde geändert",
    "personalData": "Persönliche Daten",
    "saved": "Profil gespeichert",
    "title": "Konto-Informationen"
  },
  "signupConfirmation": {
    "title": "E-Mail bestätigen"
  },
  "snackbar": {
    "connectionIssue": "Die Anfrage konnte nicht ausgeführt werden. Möglicherweise besteht keine oder nur eine langsame Internetverbindung."
  },
  "success": {
    "accountDeleted": "Konto wurde gelöscht.",
    "emailVerificationSent": "Bestätigungs-E-Mail wurde versendet.",
    "passwordUpdated": "Passwort wurde aktualisiert.",
    "profileSaved": "Profil wurde gespeichert."
  },
  "tasks": {
    "add": "Aufgabe erstellen",
    "confirmDelete": "Aufgabe wirklich löschen?",
    "delete": "Aufgabe löschen",
    "edit": "Aufgabe bearbeiten",
    "fields": {
      "addPhoto": "Foto hinzufügen",
      "archived": "Archiviert",
      "assignees": "Bearbeiter",
      "color": "Farbe",
      "description": "Beschreibung",
      "done": "Erledigt",
      "photos": "Fotos",
      "priority": "Priorität",
      "requirements": "Voraussetzungen",
      "title": "Titel"
    },
    "filter": {
      "archived": "Archiviert",
      "done": "Erledigt",
      "open": "Offen"
    },
    "markdown": {
      "edit": "Bearbeiten",
      "empty": "_Keine Beschreibung_",
      "preview": "Vorschau"
    },
    "markUnread": "Als ungelesen markieren",
    "noColor": "Keine Farbe",
    "noTasks": "Keine Aufgaben vorhanden",
    "priority": {
      "high": "Hoch",
      "icon": {
        "label": "Priorität: {{level}}"
      },
      "low": "Niedrig",
      "medium": "Mittel"
    },
    "title": "Aufgaben",
    "viewImage": "Bild anzeigen"
  },
  "validation": {
    "emailInvalid": "Bitte eine gültige E-Mail angeben.",
    "minLength": "Mindestens {{count}} Zeichen",
    "passwordMismatch": "Passwörter stimmen nicht überein.",
    "passwordStrength": "Min. 8 Zeichen mit Groß-/Kleinbuchstaben, Ziffer und Sonderzeichen."
  },
  "feed": {
    "actions": {
      "newGame": "hat eine Erlegung eingetragen",
      "updateGame": "hat eine Erlegung aktualisiert",
      "newTask": "hat eine Aufgabe erstellt",
      "updateTask": "hat eine Aufgabe aktualisiert",
      "taskStatusChange": "hat eine Aufgabe abgeschlossen",
      "taskReopened": "hat eine Aufgabe wieder geöffnet",
      "mapUpdate": "hat die Karte aktualisiert",
      "mapMarkerCreate": "hat einen Marker hinzugefügt",
      "mapMarkerUpdate": "hat einen Marker aktualisiert",
      "mapMarkerDelete": "hat einen Marker entfernt",
      "mapPolygonCreate": "hat eine Fläche hinzugefügt",
      "mapPolygonUpdate": "hat eine Fläche aktualisiert",
      "mapPolygonDelete": "hat eine Fläche entfernt",
      "releaseNotification": "Neue Version verfügbar",
      "hideCreate": "hat einen Ansitz erstellt",
      "hideUpdate": "hat einen Ansitz aktualisiert",
      "hideDelete": "hat einen Ansitz gelöscht"
    },
    "fields": {
      "title": "Titel",
      "description": "Beschreibung",
      "requirements": "Anforderungen",
      "priority": "Priorität",
      "archived": "Archiviert",
      "color": "Farbe",
      "species": "Wildart",
      "sex": "Geschlecht",
      "age": "Alter",
      "date": "Datum",
      "hunter": "Jäger",
      "location": "Standort",
      "sample": "Probe",
      "time": "Uhrzeit",
      "comment": "Kommentar",
      "name": "Name",
      "type": "Typ",
      "hideRef": "Ansitz",
      "fill": "Füllung",
      "coordinates": "Koordinaten",
      "tagIds": "Tags"
    },
    "values": {
      "true": "Ja",
      "false": "Nein"
    },
    "changesSummary": "{{count}} Änderungen",
    "valueChanged": "{{field}} geändert",
    "expand": "Details anzeigen",
    "collapse": "Details ausblenden",
    "time": {
      "justNow": "Gerade eben",
      "minutesAgo": "vor {{count}} Min.",
      "hoursAgo": "vor {{count}} Std.",
      "daysAgo": "vor {{count}} Tagen"
    }
  },
  "stockFeed": {
    "actions": {
      "addition": "hat Lagerbestand hinzugefügt",
      "removal": "hat Lagerbestand entnommen",
      "reservation": "hat eine Vormerkung angelegt",
      "fulfilled": "hat eine Vormerkung erfüllt",
      "cancelled": "hat eine Vormerkung storniert"
    },
    "quantity": "{{delta}}"
  },
  "weather": {
    "selectEntry": "Vorhersage für diese Uhrzeit auswählen"
  },
  "releaseNotes": {
    "title": "Das ist neu",
    "historyTitle": "Neuigkeiten",
    "version": "Version {{version}}",
    "gotIt": "Verstanden",
    "empty": "Noch keine Neuigkeiten vorhanden.",
    "types": {
      "feature": "Neu",
      "improvement": "Verbessert",
      "fix": "Behoben"
    }
  }
}
